import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import ErrorBoundary from '@nhl/nhl-react-ui/lib/ErrorBoundary';

import PageWrapper from 'media-base-ui/views/layouts/pageWrapper';

const NoMatch = lazy(() => import('media-base-ui/views/pages/noMatch'));

const Entry = lazy(() => import('../../pages/entry'));
const Profile = lazy(() => import('../../pages/profile'));
const EmailSubscriptions = lazy(() => import('../../pages/emailSubscriptions'));
const Password = lazy(() => import('../../pages/password'));

const isEntryPath = () => window.location.pathname === "/account/ui" || window.location.pathname === "/account/ui/";

const getLocationClass = () => isEntryPath() ? 'entry' : '';

const PublicApp = () => (
    <PageWrapper
        isAccountApp={true}
        authenticated={false}
        hideWrapperContent={isEntryPath()}
        wrapperClassName={getLocationClass()}>
            <ErrorBoundary>
                <Suspense fallback={<LoadingDisplay isLoading={true}/>}>
                    <Routes>
                        <Route path="/" element={<Entry />}/>
                        <Route
                            path="/createProfile"
                            element={<Profile createMode={true} />}
                        />
                        <Route
                            path="/emailSubscriptions"
                            element={<EmailSubscriptions createMode={true} />}
                        />
                        <Route
                            path="/resetPassword"
                            element={<Password resetMode={true} />}
                        />
                        <Route component={<NoMatch />}/>
                    </Routes>
                </Suspense>
            </ErrorBoundary>
    </PageWrapper>
);

export default PublicApp;
